'use client'

/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */

import React, { useState, useEffect } from 'react'
import parse, { domToReact } from 'html-react-parser'
import styles from './Ntabs.module.scss'
import { convertToClassName } from '../NColumnGrid/utils'

const NTabs = ({ groupedSectionCardsMap, activeStyles, inactiveStyles, sectionVariantForStyling }) => {
  const [nTabsActiveTab, setnTabsActiveTab] = useState(groupedSectionCardsMap.keys().next().value)
  const activeTabData = groupedSectionCardsMap.get(nTabsActiveTab) || []
  const firstCardInActiveTab = activeTabData.length > 0 ? activeTabData[0] : null

  useEffect(() => {
    const cardsWithActiveTab = document.querySelectorAll(`.${convertToClassName(nTabsActiveTab)}`)

    cardsWithActiveTab.forEach(card => {
      // Remove existing inactive classes
      if (card.classList.contains(inactiveStyles)) {
        card.classList.remove(inactiveStyles)
      }
      card.classList.add(activeStyles)
    })

    Array.from(groupedSectionCardsMap.keys()).forEach(className => {
      const elements = document.querySelectorAll(`.${convertToClassName(className)}`)

      elements.forEach(element => {
        if (element.classList.contains(inactiveStyles)) {
          element.classList.remove(inactiveStyles)
        }

        const isActive = Array.from(cardsWithActiveTab).some(activeElement => activeElement.isEqualNode(element))

        if (!isActive) {
          element.classList.add(inactiveStyles)
        }
      })
    })
  }, [nTabsActiveTab, activeStyles, inactiveStyles])

  const getModifiedHtml = htmlContent => {
    return parse(htmlContent, {
      replace: (domNode: any) => {
        if (domNode.name === 'a') {
          const { attribs, children } = domNode
          return (
            <a href={attribs.href} target="_blank" rel="noopener noreferrer">
              {domToReact(children)}
            </a>
          )
        }
        return domNode
      },
    })
  }

  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabButtons}>
        {Array.from(groupedSectionCardsMap).map(([mapKey, _mapValue]) => {
          return (
            <div key={mapKey}>
              <button
                type="button"
                onClick={() => {
                  setnTabsActiveTab(mapKey)
                }}
                style={{
                  backgroundColor:
                    nTabsActiveTab === mapKey
                      ? '#040222'
                      : sectionVariantForStyling === 'plainBackground'
                        ? '#f5f5f5'
                        : '#fff',
                  color: nTabsActiveTab === mapKey ? '#fff' : '#040222',
                }}>
                <p>{mapKey}</p>
              </button>
            </div>
          )
        })}
      </div>
      {firstCardInActiveTab?.tabSectionHeading && (
        <div className={styles.tabSectionHeading}>
          <h3>{getModifiedHtml(firstCardInActiveTab.tabSectionHeading)}</h3>
          {firstCardInActiveTab.tabSectionHeadingPara && (
            <p>{getModifiedHtml(firstCardInActiveTab.tabSectionHeadingPara)}</p>
          )}
        </div>
      )}
    </div>
  )
}

export default NTabs
